export default __webpack_public_path__ + "static/pecet-1c937c93f84dab70bcbb389c864cb84f.webp";